<template>
  <Empty text="您没有处方记录" v-if="finished && list.length <= 0">
    <template v-slot:content>
      <router-link v-if="!$isInWxMP" :to="{path: '/doctor-list'}">
        <button class="empty-btn">去问诊</button>
      </router-link>
    </template>
  </Empty>
  <div class="list" v-else>
    <van-pull-refresh v-model="refreshing" @refresh="getData(true)">
      <van-list
        :loading="loading"
        :finished="finished"
        :error="error"
        finished-text="没有更多了"
        @load="getData"
      >
        <Item :itemData="item" v-for="(item, index) in list" :key="index"/>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Item from '@/components/prescription/prescription-item.vue';
import Empty from '@/components/empty.vue';
import { getPrescriptionList } from '@/api/prescription';

export default {
  components: {
    Item,
    Empty,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      refreshing: false,
      list: [],
      pageSize: 10,
      pageNo: 1,
      channelString: this.$route.query.channelString || '',
    };
  },
  methods: {
    /**
     * 获取处方列表
     */
    getData(refreshing) {
      if (this.loading) return;
      this.loading = true;

      if (refreshing) {
        this.finished = false;
        this.error = false;
        this.pageNo = 1;
        this.list = [];
      }

      if (this.finished) return;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      if (this.channelString === '共管平台'){
        params = {
          ...params,
          channelCodeList: '10027',
        }
      }
      getPrescriptionList(params).then((res) => {
        if (res && res.code === 200) {
          this.list = [...this.list, ...res.data.content];
          this.loading = false;
          if (this.refreshing) this.refreshing = false;
          // 判断是否是第一页
          if (this.pageNo === 1) {
            document.scrollingElement.scrollTop = 0;
          }

          // 判断是否加载完毕
          if (res.data.totalCount <= this.list.length) {
            this.finished = true;
          } else {
            this.pageNo += 1;
          }
        } else {
          this.error = true;
          this.loading = false;
          this.finished = false;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.list {
  padding: 12px 15px;
}

.empty-btn {
  background: linear-gradient(151deg, #42e9a4 0%, #01bb6e 100%);
  border-radius: 21px;
  padding: 8px 22px;
  margin-top: 5px;

  @include font(15px, 21px, #fff);
}
</style>
